import { render, staticRenderFns } from "./CommonModalWithWithdrawInfo.vue?vue&type=template&id=32b5ec71&lang=pug&"
import script from "./CommonModalWithWithdrawInfo.vue?vue&type=script&lang=ts&"
export * from "./CommonModalWithWithdrawInfo.vue?vue&type=script&lang=ts&"
import style0 from "./CommonModalWithWithdrawInfo.vue?vue&type=style&index=0&id=32b5ec71&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports